import { Extension } from '@tiptap/core'

/**
 * Paragraph/heading text alignment for counselor essay view.
 * Mirrors the student EssayWriter extension so content_text / content_json
 * with text-align (center/right/justify) render correctly without an extra package.
 */
const TextAlignExtension = Extension.create({
	name: 'textAlign',

	addOptions() {
		return {
			types: ['heading', 'paragraph'],
			alignments: ['left', 'center', 'right', 'justify'],
			defaultAlignment: 'left',
		}
	},

	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					textAlign: {
						default: this.options.defaultAlignment,
						parseHTML: element => {
							const align = element.style.textAlign
							return this.options.alignments.includes(align)
								? align
								: this.options.defaultAlignment
						},
						renderHTML: attributes => {
							if (
								!attributes.textAlign ||
								attributes.textAlign === this.options.defaultAlignment
							) {
								return {}
							}
							return { style: `text-align: ${attributes.textAlign}` }
						},
					},
				},
			},
		]
	},

	addCommands() {
		return {
			setTextAlign:
				alignment =>
				({ commands }) => {
					if (!this.options.alignments.includes(alignment)) {
						return false
					}
					return this.options.types
						.map(type =>
							commands.updateAttributes(type, { textAlign: alignment }),
						)
						.some(Boolean)
				},
			unsetTextAlign:
				() =>
				({ commands }) =>
					this.options.types
						.map(type => commands.resetAttributes(type, 'textAlign'))
						.some(Boolean),
		}
	},
})

export default TextAlignExtension
